module.exports = __webpack_public_path__ + "static/media/appstore-2b.223f2199.png";